/**
 * Handle Pharmacist workflow interface
 */
const $inject = ["PharmacistService", "MessageService", "$state", "$rootScope"];

class PharmacistController {
  constructor(PharmacistService, MessageService, $state, $rootScope) {
    this.state = $state;

    if (this.state.current.name === "app.pharmacist") {
      this.state.go("app.pharmacist.details");
    }

    $rootScope.$on("$stateChangeSuccess", function (event, toState, toParams, fromState, fromParams) {
      //  MessageService.clearAll();
    });
  }
}

PharmacistController.$inject = $inject;

export default PharmacistController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/pharmacist/controllers/pharmacist.controller.js
 **/